import { TravelFilter, TravelFilterSelection } from '@/features/travelFilter/types'
import { Col } from 'react-bootstrap'
import MultiMonthPicker from '@/components/models/travel/filter/TravelFilterNav/selectors/MonthFilterSelector/MultiMonthPicker'
import FilterSelectorButtons from '@/components/models/travel/filter/TravelFilterNav/FilterSelectorButtons'

interface Props {
  filter: TravelFilter
  selection: TravelFilterSelection
  setSelection: (selection: string[]) => void
  applySelection: () => void
}

const MonthFilterSelector = ({ filter, selection, setSelection, applySelection }: Props) => {
  const handleResetSelection = () => {
    setSelection([])
  }

  return (
    <>
      <Col xs="12">
        <MultiMonthPicker selected={selection as string[]} setSelected={setSelection} options={filter.options} />
      </Col>
      <Col xs={12}>
        <FilterSelectorButtons handleReset={handleResetSelection} handleApply={applySelection} />
      </Col>
    </>
  )
}

export default MonthFilterSelector
